import { Box, Button, Tooltip } from '@mui/material';

export default function AuthorizeNet() {
  function getCurrentUrl() {
    return `${window.location.protocol}//${window.location.hostname}`;
  }

  const openAuthorizeNetSealWindow = () => {
    window.open(
      `https://verify.authorize.net/anetseal/?pid=ae778609-27db-4518-a74f-ceb4639aa4e4&rurl=${getCurrentUrl()}`,
      'AuthorizeNetVerification',
      'width=600,height=430,dependent=yes,resizable=yes,scrollbars=yes,menubar=no,toolbar=no,status=no,directories=no,location=yes'
    );
    return false;
  };

  return (
    <>
      <script
        dangerouslySetInnerHTML={{
          __html: `var ANS_customer_id="ae778609-27db-4518-a74f-ceb4639aa4e4";`,
        }}
      />
      <Tooltip title="Verified Authorize.Net Merchant" arrow>
        <Button
          onClick={openAuthorizeNetSealWindow}
          sx={{
            display: 'inline-block',
            p: 0,
            minWidth: 'inherit',
            maxHeight: 60,
            mt: '-4px',
            '&:hover, &:active, &:focus': { backgroundColor: 'transparent' },
          }}
        >
          <Box
            component="img"
            src="/assets/images/secure90x72.gif"
            width={75}
            height={60}
            alt="Authorize.Net Merchant - Click to Verify"
            className="footer-seal-authorize"
            loading="lazy"
          />
        </Button>
      </Tooltip>
    </>
  );
}
